if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        /*
          RELAXIM 追加: テーマはドロップダウン型 variant-selects とラジオ型 variant-radios の
          どちらも使い得るため、存在する方を picker として保持する。
        */
        this.variantSelects = this.querySelector('variant-radios') || this.querySelector('variant-selects');
        this.submitButton = this.querySelector('[type="submit"]');
      }

      rlxProductFormHost() {
        return this.querySelector('product-form');
      }

      rlxIsCartAddBusy() {
        const productFormHost = this.rlxProductFormHost();
        return !!(
          productFormHost &&
          (typeof productFormHost.rlxIsCartAddBusy === 'function'
            ? productFormHost.rlxIsCartAddBusy()
            : productFormHost.rlxCartAddBusy === true)
        );
      }

      rlxRememberServerPurchaseState(purchasable, variantId = null) {
        const productFormHost = this.rlxProductFormHost();
        const resolvedVariantId =
          variantId !== null && variantId !== undefined
            ? variantId
            : this.currentVariant
              ? this.currentVariant.value
              : null;
        if (
          !productFormHost ||
          typeof productFormHost.rlxRememberVariantServerPurchaseState !== 'function'
        ) {
          return false;
        }
        return productFormHost.rlxRememberVariantServerPurchaseState(
          resolvedVariantId,
          purchasable === true
        );
      }

      /* 既存名は維持し、busyだけでなく恒久理由・server可否を含む合成状態を再適用する */
      rlxReapplyCartAddBusy() {
        const productFormHost = this.rlxProductFormHost();
        if (
          productFormHost &&
          typeof productFormHost.rlxApplyCurrentSubmissionState === 'function'
        ) {
          productFormHost.rlxApplyCurrentSubmissionState();
          return;
        }
        if (
          this.rlxIsCartAddBusy() &&
          productFormHost &&
          typeof productFormHost.rlxApplyCartAddBusy === 'function'
        ) {
          productFormHost.rlxApplyCartAddBusy();
        }
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;
      rlxSubmitObserver = undefined;
      /*
        RELAXIM 追加: 数量ルール取得要求の世代番号。要求ごとに1つ進め、
        応答適用時に最新世代であることを必須条件にする（同一variantの後着破棄用）。
      */
      rlxQuantityRequestGeneration = 0;
      /*
        RELAXIM 追加: 数量上限到達（setQuantityBoundries()のremaining<=0分岐）によって
        この実装自身が購入導線を無効化した専用状態。売り切れ・在庫不足・無効variant等、
        他の原因による無効化と区別し、updateQuantityRules()の復帰判定でのみ使用する。
        trueへ設定するのはremaining<=0分岐のみ。falseへ戻すのは復帰条件を満たした時のみ。
      */
      rlxQuantityLimitDisabled = false;
      /*
        RELAXIM 追加: 数量上限到達（rlxQuantityLimitDisabled=true）に切り替わった時点の
        hidden variant ID（this.currentVariant.value）を記録する。無効な組合せ選択中は
        Dawnがhidden variant IDを旧variantのまま更新しないため、復帰判定時に
        「記録時点から本当にhidden variant IDが変わっていないか」を照合する材料にする。
      */
      rlxQuantityLimitVariantId = null;
      /*
        RELAXIM 追加: 数量上限到達に切り替わった時点の購入ボタン文言を記録する。
        無効な組合せ選択はvariant-selects/variant-radios側が独自に購入ボタンの文言・disabledを
        書き換える（本クラスのrlxSyncSubmitSoldOut等を経由しない）ため、hidden variant IDが
        変化していなくても文言が記録時点と食い違っていれば、復帰対象ではない別状態とみなす。
      */
      rlxQuantityLimitSubmitText = null;

      connectedCallback() {
        if (!this.input) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        this.rlxObserveSubmitState();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if (event.data.sectionId !== sectionId) return;
          /*
            RELAXIM 追加（第16回検品 不合格1）: 世代更新・スピナー操作・
            updateQuantityRules()・setQuantityBoundries()より前に、response ID
            （event.data.variant.id）・current ID（this.currentVariant.value）・
            更新HTML ID（rlxExtractUpdatedVariantId）の3つをString()正規化して
            比較する。第14回まではevent.data.variant未指定時（空）を素通りさせて
            いたが、第16回検品でresponse ID欠落時に同一variant上限状態から全面復帰
            してしまう不具合が実測されたため、3値のいずれかが空でも即破棄する。
            拒否時はrlxQuantityRequestGeneration・スピナー・数量属性・数量UI・
            購入ボタン・文言・hidden variant ID・上限フラグ・記録ID・記録文言・
            飛行中cartUpdateの有効性のいずれも一切変更しない（副作用0件）。
            世代番号を進めないことで、この破棄イベントが現在飛行中の正規cartUpdate
            応答を「古い世代」として誤って無効化するのを防ぐ。
            updateQuantityRules()冒頭の更新HTML ID共通ガード（第15回追加）は
            防御の二重化として維持し、ここでは購読側での早期判定を行う。
          */
          const responseVariantId =
            event.data.variant && event.data.variant.id !== undefined && event.data.variant.id !== null
              ? String(event.data.variant.id)
              : '';
          const currentVariantIdAtEvent =
            this.currentVariant && this.currentVariant.value ? String(this.currentVariant.value) : '';
          const updatedVariantIdAtEvent = this.rlxExtractUpdatedVariantId(event.data.sectionId, event.data.html);
          const normalizedUpdatedVariantIdAtEvent =
            updatedVariantIdAtEvent !== null && updatedVariantIdAtEvent !== undefined
              ? String(updatedVariantIdAtEvent)
              : '';
          if (
            !responseVariantId ||
            !currentVariantIdAtEvent ||
            !normalizedUpdatedVariantIdAtEvent ||
            responseVariantId !== currentVariantIdAtEvent ||
            responseVariantId !== normalizedUpdatedVariantIdAtEvent
          ) {
            return;
          }
          /*
            RELAXIM 追加: 切替HTMLを正本にするため、この時点で世代を進めて
            飛行中の cartUpdate 応答を全て無効化する。同一variantのままでも
            古い応答を後から適用しない。
            無効化した要求の finally はスピナーを消さないので、ここで消す。
          */
          this.rlxQuantityRequestGeneration += 1;
          this.rlxHideQuantitySpinner();
          /*
            RELAXIM 追加: variantChangeだけに isVariantChange:true を渡す。
            cartUpdate（fetchQuantityRules経由）は渡さないため、上限到達variantから
            別variantへの正規切替はvariantChange経由でしか成立しない
            （rlxCanRecoverFromQuantityLimitViaVariantChange()参照）。
            responseVariantIdも合わせて渡し、更新HTML内variant IDとの4値照合に使う。
          */
          this.updateQuantityRules(event.data.sectionId, event.data.html, {
            isVariantChange: true,
            responseVariantId: responseVariantId || null,
            updatedVariantId: normalizedUpdatedVariantIdAtEvent || null,
          });
          this.setQuantityBoundries();
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
        if (this.rlxSubmitObserver) {
          this.rlxSubmitObserver.disconnect();
          this.rlxSubmitObserver = undefined;
        }
        /*
          RELAXIM 追加: 切断時に世代を進め、飛行中の応答を全て無効化する。
          切断後に返ってきた応答でDOMを触らない。
          無効化した要求の finally はスピナーを消さないため、ここで消す。
          同一要素を再接続しても読込表示が残らない。
        */
        this.rlxQuantityRequestGeneration += 1;
        this.rlxHideQuantitySpinner();
      }

      /*
        RELAXIM 追加（第14回検品 不合格2）: window由来など外部由来の文字列を
        innerHTMLへ反映する際に、HTML特殊文字をエスケープしてマークアップとして
        解釈されないようにする。textContent設定を主とし、innerHTMLはこの
        エスケープ済み文字列だけを反映する保険として使う。
      */
      rlxEscapeHtml(value) {
        return String(value).replace(/[&<>"']/g, (char) => {
          switch (char) {
            case '&':
              return '&amp;';
            case '<':
              return '&lt;';
            case '>':
              return '&gt;';
            case '"':
              return '&quot;';
            case "'":
              return '&#39;';
            default:
              return char;
          }
        });
      }

      /* RELAXIM 追加: 数量ルール取得中のスピナーを隠す（存在しなければ何もしない） */
      rlxHideQuantitySpinner() {
        const spinner = this.querySelector('.quantity__rules-cart .loading__spinner');
        if (spinner) spinner.classList.add('hidden');
      }

      /*
        RELAXIM 追加: 数量UIの有効・無効を購入可否へ合わせる。
        Dawn標準の updateQuantityRules() は data-cart-quantity / data-min / data-max / step だけを
        同期するため、売り切れと販売可能を切替えると disabled と見た目用クラスが前の状態のまま残る。
        要素は差し替えず属性だけを操作するので、this.input などの参照は保持される。
      */
      rlxSyncQuantityDisabled(disabled) {
        const wrapper = this.quantityForm ? this.quantityForm.querySelector('.quantity') : null;
        const buttons = this.quantityForm
          ? this.quantityForm.querySelectorAll('.quantity__button')
          : [];

        if (this.input) {
          this.input.disabled = disabled;
        }
        buttons.forEach((button) => {
          button.disabled = disabled;
          button.classList.toggle('disabled', disabled);
          button.setAttribute('aria-disabled', disabled ? 'true' : 'false');
        });
        if (wrapper) {
          wrapper.classList.toggle('rlx-quantity-disabled', disabled);
        }
      }

      /*
        RELAXIM 追加: バリエーション切替後も数量欄の外側ラッパーを更新HTMLへ合わせる。
        初期Liquidは売り切れ時に hidden属性・hiddenクラス・aria-hidden="true" の3状態を
        Quantity-Formへ付けるが、Dawn標準は内側の数量属性だけを転記するため、切替前の
        可視状態が残っていた。quantityFormUpdatedを正本に3状態を個別に双方向同期する。
        要素自体は差し替えず、this.quantityFormと配下要素への既存参照を保持する。
      */
      rlxSyncQuantityFormVisibility(quantityFormUpdated) {
        if (!this.quantityForm || !quantityFormUpdated) return;

        this.quantityForm.toggleAttribute('hidden', quantityFormUpdated.hasAttribute('hidden'));
        this.quantityForm.classList.toggle('hidden', quantityFormUpdated.classList.contains('hidden'));

        const updatedAriaHidden = quantityFormUpdated.getAttribute('aria-hidden');
        if (updatedAriaHidden !== null) {
          this.quantityForm.setAttribute('aria-hidden', updatedAriaHidden);
        } else {
          this.quantityForm.removeAttribute('aria-hidden');
        }
      }

      /*
        RELAXIM 追加: バリエーションが存在しない場合、Dawnは variantChange を発行せず
        setUnavailable() で購入ボタンだけを無効化する。購入ボタンの disabled を監視して
        数量UIを追従させ、どの経路でも購入可否と一致させる。
      */
      rlxObserveSubmitState() {
        if (!this.submitButton || typeof MutationObserver === 'undefined') return;
        this.rlxSubmitObserver = new MutationObserver(() => {
          this.rlxHandleSubmitStateObserved();
        });
        this.rlxSubmitObserver.observe(this.submitButton, {
          attributes: true,
          attributeFilter: ['disabled'],
        });
        /*
          RELAXIM 追加: Observer登録は以後の変化しか検知しない。切断中に購入ボタンが
          無効化された要素を再接続した場合、登録直後の現在状態を一度数量UIへ同期しないと、
          再接続後も数量UIだけ有効のまま残ってしまう。
        */
        this.rlxHandleSubmitStateObserved();
      }

      /*
        RELAXIM 追加: 外部（variant picker等）の正規variant切替処理による購入ボタンのdisabled変化に
        追従する。Observer自身が購入ボタンのdisabledを外すことはない（外部が外した後の追従のみ）。
        - 購入ボタンが無効化された場合は、数量上限専用状態か否かに関わらず数量UIを追従して無効化する
          （hidden IDには触れない。既存の売り切れ・無効variant等の一般ケースを維持するため）。
        - 購入ボタンが外部から有効化され、かつ数量上限専用状態(rlxQuantityLimitDisabled)中である場合は、
          hidden variant IDが記録IDと一致し、variant pickerがあれば現在選択が有効でhidden IDと一致する
          ことを確認できた時だけ、数量上限専用状態を解除し数量UIとhidden IDを有効化する。
          条件を確認できなければfail-closedで数量UI・hidden IDを無効のまま維持する。
        - 数量上限専用状態でない通常の売り切れ・無効variant状態のhidden IDは、本処理で変更しない。
      */
      rlxHandleSubmitStateObserved() {
        const submitDisabledNow = this.submitButton.hasAttribute('disabled');
        if (submitDisabledNow) {
          this.rlxSyncQuantityDisabled(true);
          return;
        }
        if (this.rlxQuantityLimitDisabled) {
          if (this.rlxCanRecoverFromQuantityLimitViaObserver()) {
            this.rlxQuantityLimitDisabled = false;
            this.rlxQuantityLimitVariantId = null;
            this.rlxQuantityLimitSubmitText = null;
            if (this.currentVariant) this.currentVariant.removeAttribute('disabled');
            this.rlxSyncQuantityDisabled(false);
            this.rlxRememberServerPurchaseState(true);
            this.rlxReapplyCartAddBusy();
            return;
          }
          /*
            RELAXIM 追加: 数量上限専用状態のまま、外部処理が購入ボタンだけを
            有効化し、復帰条件（hidden ID一致・picker一致）を満たさない場合、
            可視CTAだけ押せて商品IDが送信されない不整合（第13回検品 中1）を防ぐため、
            購入ボタンをfail-closedで即再無効化し、文言も記録済みの数量上限文言へ戻す。
            hidden variant ID・数量UIは元々disabledのまま変更していないため、
            ここで無効化し直すのは購入ボタンと文言だけでよい。
            setAttribute('disabled')は既にdisabledなら実質変化なしだが、今回は
            submitDisabledNow===falseの分岐に入っているため必ずfalse→trueの実変化になり、
            MutationObserverが1回だけ再発火する。再発火時はsubmitDisabledNow===trueの
            最初のif分岐に入って即returnするため、無限ループにはならない。
            Observerが購入ボタンを自分で有効化することはない（このelseは無効化のみ）。
          */
          this.submitButton.setAttribute('disabled', 'disabled');
          const submitTextEl = this.submitButton.querySelector('span');
          if (submitTextEl) {
            if (
              this.rlxQuantityLimitSubmitText !== null &&
              this.rlxQuantityLimitSubmitText !== undefined &&
              this.rlxQuantityLimitSubmitText !== ''
            ) {
              submitTextEl.innerHTML = this.rlxQuantityLimitSubmitText;
            } else {
              /*
                RELAXIM 追加（第14回検品 不合格2）: 記録済み文言が無い場合、外部が
                「購入する」等へ書き換えた文言を放置しない。
                window.variantStrings.soldOut（Dawn標準のテーマロケール文字列）が
                あればそれを使い、window・variantStrings・soldOutのいずれかが無い・
                空なら最終安全文言「売り切れ」を使う。この文言はwindowグローバル
                経由の外部由来のためtextContentへ設定してHTMLとして解釈させず、
                innerHTMLへはHTMLエスケープ後の同一文字列だけを反映する
                （生のマークアップとして解釈されるのを防ぐ）。
              */
              const themeSoldOutText =
                typeof window !== 'undefined' &&
                window &&
                window.variantStrings &&
                typeof window.variantStrings.soldOut === 'string' &&
                window.variantStrings.soldOut !== ''
                  ? window.variantStrings.soldOut
                  : '売り切れ';
              submitTextEl.textContent = themeSoldOutText;
              submitTextEl.innerHTML = this.rlxEscapeHtml(themeSoldOutText);
            }
          }
          this.rlxSyncQuantityDisabled(true);
          return;
        }
        this.rlxSyncQuantityDisabled(false);
      }

      setQuantityBoundries() {
        /*
          RELAXIM 追加: data-max が未設定・"null"・空文字・数値に解釈できない値の場合、
          parseInt が NaN を返す。NaN をそのまま min/max/value へ伝播させると
          input.max へ null を代入した際に属性が文字列 "null" として残ってしまうため、
          Number.isFinite で有効な数値かどうかを先に確定させる。
        */
        const rawMax = this.input.dataset.max;
        const parsedMax = rawMax ? parseInt(rawMax, 10) : NaN;
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity, 10) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min, 10) : 1,
          max: Number.isFinite(parsedMax) ? parsedMax : null,
          step: this.input.step ? parseInt(this.input.step, 10) : 1,
        };

        const remaining = data.max === null ? null : data.max - data.cartQuantity;

        /*
          RELAXIM 追加: 残り購入可能数（quantity_rule.max からカート内数量を引いた値）が
          0以下の場合、数量上限に到達または超過している。0や負数を min/max/value へ
          設定すると顧客に無意味な数量が見え、購入ボタンが有効なままだと購入導線が壊れる。
          正の数量ルール最小値を維持したまま、数量UIと購入ボタンをfail-closedで無効化する。
        */
        if (remaining !== null && remaining <= 0) {
          /*
            RELAXIM 追加: この時点のhidden variant IDと購入ボタン文言を復帰判定用に記録する。
            数量上限状態へ初めて入る時（rlxQuantityLimitDisabledがまだfalseの時）だけ記録し、
            同じ専用状態が続いている間の後続呼び出し（数量フォーム欠落時の再計算等）では
            上書きしない。updateQuantityRules()がsetQuantityBoundries()より先に呼ばれる経路
            （variantChange・cartUpdate）では、ここに来るまでに購入ボタン文言の同期が
            先に済んでいるため、記録される文言は「この上限到達状態にふさわしい文言」になる。
          */
          if (!this.rlxQuantityLimitDisabled) {
            this.rlxQuantityLimitVariantId = this.currentVariant ? this.currentVariant.value : null;
            const limitSubmitTextEl = this.submitButton ? this.submitButton.querySelector('span') : null;
            this.rlxQuantityLimitSubmitText = limitSubmitTextEl ? limitSubmitTextEl.innerHTML : null;
          }
          this.rlxQuantityLimitDisabled = true;
          this.rlxRememberServerPurchaseState(false);
          this.input.min = data.min;
          this.input.max = data.min;
          this.input.value = data.min;
          this.rlxSyncQuantityDisabled(true);
          if (this.submitButton) {
            this.submitButton.setAttribute('disabled', 'disabled');
          }
          /*
            RELAXIM 追加: 数量UI・購入ボタンだけでなく、hidden .product-variant-id も
            無効化する。無効化しないと、初期Liquid（数量上限到達時はhidden IDが無効）と
            JS遷移後の状態が不一致になり、disabledなhidden inputはフォーム送信から除外される
            仕様と食い違ったまま購入導線が成立してしまう。
          */
          if (this.currentVariant) {
            this.currentVariant.setAttribute('disabled', 'disabled');
          }
          this.rlxReapplyCartAddBusy();
          publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
          return;
        }

        let min = data.min;
        if (remaining !== null) min = Math.min(min, remaining);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        if (remaining !== null) {
          this.input.max = remaining;
        } else {
          this.input.removeAttribute('max');
        }
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        /*
          RELAXIM 追加: 応答が返るまでに別バリエーションへ切替わることがあるため、
          要求時の hidden variant ID を控えておく。
        */
        const requestedVariantId = this.currentVariant.value;
        /*
          RELAXIM 追加: 同一variantに対する要求が並行した場合、要求時刻の順と
          応答の到着順は一致しない。requestedVariantId の比較だけでは新旧を判別できないため、
          要求ごとに単調増加する世代番号を発行し、最新世代の応答だけを適用する。
        */
        const requestGeneration = (this.rlxQuantityRequestGeneration += 1);
        const spinnerAtRequest = this.querySelector('.quantity__rules-cart .loading__spinner');
        if (spinnerAtRequest) spinnerAtRequest.classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => {
            /*
              RELAXIM 追加: 本文を解析する前に HTTP ステータスを確認する。
              ok=false のとき、エラーページ本文には数量フォームも購入ボタンも無いため、
              そのまま解析すると「数量フォーム欠落」とみなされて数量UIが無効化され、
              直前まで整合していた画面が壊れる。
              記録だけ残して null を返し、以降の適用処理へ進ませない。
              スピナーは finally が最新要求として解除する。
              通信失敗（Promise reject）は従来どおり catch 側で処理する。
            */
            if (!response.ok) {
              /*
                RELAXIM 変更（IMP-D6）: ログは世代・variant照合の後にだけ出す。
                stale要求（切替済みvariant・旧世代）の失敗は記録しない。
              */
              const activeVariantIdAtError = this.currentVariant ? this.currentVariant.value : null;
              if (
                activeVariantIdAtError === requestedVariantId &&
                this.rlxQuantityRequestGeneration === requestGeneration
              ) {
                console.error(
                  `RELAXIM: 数量ルールの取得に失敗しました (HTTP ${response.status})`
                );
              }
              return null;
            }
            return response.text();
          })
          .then((responseText) => {
            /* RELAXIM 追加: HTTPエラー時は数量ルールHTMLとして解析しない */
            if (responseText === null) return;
            /*
              RELAXIM 追加: 後着応答の破棄。バリエーションAの取得中にBへ切替わった場合、
              Aの応答でBの画面（数量欄・min/max/step・数量ルール文言・購入ボタン）を上書きしない。
            */
            const activeVariantId = this.currentVariant ? this.currentVariant.value : null;
            if (activeVariantId !== requestedVariantId) return;
            /*
              RELAXIM 追加: 同一variantでも、より新しい要求が発行済みなら適用しない。
              切断時も世代が進むため、切断後の応答もここで止まる。
              数量属性・数量UI・購入ボタン・文言のいずれにも触れずに return する。
            */
            if (this.rlxQuantityRequestGeneration !== requestGeneration) return;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch(() => {
            /*
              RELAXIM 変更（IMP-D6・R2c-009）: catch側もHTTP分岐と同じ世代・variant照合を通し、
              stale要求（切替済みvariant・旧世代）の失敗は記録しない。
              出力は固定リテラルのみ（Error由来の値〔名称・stack・URL〕を一切出さない）。
            */
            const activeVariantIdAtReject = this.currentVariant ? this.currentVariant.value : null;
            if (
              activeVariantIdAtReject === requestedVariantId &&
              this.rlxQuantityRequestGeneration === requestGeneration
            ) {
              console.error('RELAXIM: 数量ルールの取得に失敗しました（通信エラー）');
            }
          })
          .finally(() => {
            /*
              RELAXIM 追加: 古い要求の完了でスピナーを消さない。
              最新要求が完了した時（またはこの要求が最新のまま失敗した時）だけ消す。
            */
            if (this.rlxQuantityRequestGeneration !== requestGeneration) return;
            this.rlxHideQuantitySpinner();
          });
      }

      updateQuantityRules(sectionId, html, options = {}) {
        /*
          RELAXIM 追加: isVariantChangeはvariantChangeイベント経由の呼び出しでのみ
          trueになる（connectedCallback参照）。cartUpdate（fetchQuantityRules）や
          テストからの直接呼び出しはfalse扱いになり、別variantへの復帰を許可しない。
        */
        const isVariantChange = options.isVariantChange === true;
        /*
          RELAXIM 追加（第15回検品）: variantChangeの場合、数量属性を現在DOMへ
          コピーする前に、更新HTML内variant ID（#product-form-${sectionId}
          .product-variant-id）と現在のhidden variant IDを照合する。
          event.data.variant.idが現在IDと一致していても（第14回の早期破棄を通過）、
          更新HTML自体が別variantのデータを運んでいる場合は、同一variant復帰・
          別variant復帰のどちらにも進ませず、数量属性・数量UI・購入ボタンと文言・
          hidden商品ID・上限フラグ・記録ID・記録文言のいずれも変更せず即returnする。
          この共通ガードは両復帰分岐より前段に置く。cartUpdate（isVariantChange=false）
          には適用しない。抽出した更新HTML IDは後段の別variant4値照合でも再利用する。
        */
        /*
          RELAXIM 追加（第16回検品）: 購読側（connectedCallback）で既に抽出済みの
          更新HTML ID（options.updatedVariantId）があれば再利用し、同じDOM探索の
          重複を避ける。渡されていない直接呼び出し（テスト等）では従来どおり
          自前で抽出する。
        */
        const updatedVariantIdForGuard = isVariantChange
          ? options.updatedVariantId !== undefined && options.updatedVariantId !== null
            ? options.updatedVariantId
            : this.rlxExtractUpdatedVariantId(sectionId, html)
          : null;
        if (isVariantChange) {
          const currentVariantIdForGuard =
            this.currentVariant && this.currentVariant.value ? String(this.currentVariant.value) : '';
          if (
            !currentVariantIdForGuard ||
            !updatedVariantIdForGuard ||
            currentVariantIdForGuard !== String(updatedVariantIdForGuard)
          ) {
            return;
          }
        }
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        /*
          RELAXIM 追加: 切替先HTMLに数量フォームが無い場合は数量UIを無効にする。
          この場合も購入ボタンの売切れ状態を同期しないと、数量UIは無効なのに
          購入ボタンは有効なまま（または旧文言のまま）という不一致が起きる。
        */
        if (!quantityFormUpdated) {
          this.rlxRememberServerPurchaseState(false, updatedVariantIdForGuard);
          this.rlxSyncSubmitSoldOut(sectionId, html);
          this.rlxSyncQuantityDisabled(true);
          this.rlxReapplyCartAddBusy();
          return;
        }
        this.rlxSyncQuantityFormVisibility(quantityFormUpdated);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              /*
                RELAXIM 追加: 更新HTML側に属性が無い場合（例: 上限なしvariantへの切替でdata-maxが
                消える）、現在要素に古い属性を残さない。残すと setQuantityBoundries() が
                旧variantの上限を引き続き適用してしまう。
              */
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
        /*
          RELAXIM 追加: 切替先HTMLを正本として disabled と見た目用クラスを双方向に同期する。
          ただし購入ボタンが無効な間は数量UIを有効へ戻さない（fail-closed）。
          存在しない組合せを選ぶと Dawn は hidden variant ID を旧variantのまま残すため、
          その状態で cartUpdate が起きると旧variantの応答HTML（disabled なし）で
          数量UIだけが復活し、購入ボタンだけ無効という不一致が生じる。
          購入ボタンの disabled が外れた時は rlxObserveSubmitState() が数量UIを復帰させる。
        */
        const updatedInput = quantityFormUpdated.querySelector('.quantity__input');
        if (updatedInput) {
          const updatedDisabled = updatedInput.hasAttribute('disabled');
          const updatedSubmit =
            html && typeof html.getElementById === 'function'
              ? html.getElementById(`ProductSubmitButton-${sectionId}`)
              : null;
          this.rlxRememberServerPurchaseState(
            !updatedDisabled && !!updatedSubmit && !updatedSubmit.hasAttribute('disabled'),
            updatedVariantIdForGuard
          );
          /*
            RELAXIM 追加: 数量上限到達由来の専用状態（rlxQuantityLimitDisabled）だけを対象に、
            同じ現行variantの最新更新HTMLが次を全て満たした場合だけ復帰する。
            1. 更新後の残り購入可能数（quantity_rule.max - cartQuantity）が正、または上限なし。
            2. 更新HTMLの数量入力にdisabledがない。
            3. 更新HTMLの購入ボタンにdisabledがない。
            4. 更新HTMLの数量フォームと購入ボタンが両方存在する。
            5. rlxCanRecoverFromQuantityLimit()：無効な組合せ選択中の誤復帰を防ぐ追加照合
               （記録済みhidden variant ID・記録済み購入ボタン文言・variant picker現在選択の妥当性）。
            数量上限由来ではない無効化（売り切れ・在庫不足・無効variant等）はこの分岐を通らず、
            既存のsubmitDisabled維持ロジック（下のelse相当）にそのまま従うため復帰しない。
          */
          if (
            this.rlxQuantityLimitDisabled &&
            this.submitButton &&
            !updatedDisabled &&
            updatedSubmit &&
            !updatedSubmit.hasAttribute('disabled') &&
            this.rlxCanRecoverFromQuantityLimit()
          ) {
            const rawMaxAfterUpdate = this.input.dataset.max;
            const parsedMaxAfterUpdate = rawMaxAfterUpdate ? parseInt(rawMaxAfterUpdate, 10) : NaN;
            const maxAfterUpdate = Number.isFinite(parsedMaxAfterUpdate) ? parsedMaxAfterUpdate : null;
            const cartQuantityAfterUpdate = this.input.dataset.cartQuantity
              ? parseInt(this.input.dataset.cartQuantity, 10)
              : 0;
            const remainingAfterUpdate = maxAfterUpdate === null ? null : maxAfterUpdate - cartQuantityAfterUpdate;
            const quantityLimitClearedInUpdate = remainingAfterUpdate === null || remainingAfterUpdate > 0;
            if (quantityLimitClearedInUpdate) {
              this.rlxQuantityLimitDisabled = false;
              this.rlxQuantityLimitVariantId = null;
              this.rlxQuantityLimitSubmitText = null;
              this.submitButton.removeAttribute('disabled');
              /*
                RELAXIM 追加: hidden variant IDの有効化は、購入ボタンと数量UIを
                有効化するのと同じ確定分岐内で行う。
              */
              if (this.currentVariant) {
                this.currentVariant.removeAttribute('disabled');
              }
              const currentText = this.submitButton.querySelector('span');
              const updatedText = updatedSubmit.querySelector('span');
              if (currentText && updatedText) {
                currentText.innerHTML = updatedText.innerHTML;
              }
              this.rlxSyncQuantityDisabled(false);
              this.rlxReapplyCartAddBusy();
              return;
            }
          }
          /*
            RELAXIM 追加: 数量上限到達variant Aから、販売可能な別variant Bへの
            正規切替（第13回検品 中2）。variantChangeイベントに限り許可する
            （isVariantChangeがtrueの場合のみ）。cartUpdateだけ、古い/異variant応答、
            picker invalid・判定不能・ID不一致では別variant復帰を許可しない
            （rlxCanRecoverFromQuantityLimitViaVariantChange()参照）。
            section IDの一致はconnectedCallbackのvariantChange購読側で
            event.data.sectionIdとdataset.sectionを既に照合済みのため、ここでは
            再照合しない。
          */
          if (
            isVariantChange &&
            this.rlxQuantityLimitDisabled &&
            this.submitButton &&
            !updatedDisabled &&
            updatedSubmit &&
            !updatedSubmit.hasAttribute('disabled') &&
            this.rlxCanRecoverFromQuantityLimitViaVariantChange(
              options.responseVariantId || null,
              updatedVariantIdForGuard
            )
          ) {
            this.rlxQuantityLimitDisabled = false;
            this.rlxQuantityLimitVariantId = null;
            this.rlxQuantityLimitSubmitText = null;
            this.submitButton.removeAttribute('disabled');
            if (this.currentVariant) {
              this.currentVariant.removeAttribute('disabled');
            }
            const currentTextForVariantChange = this.submitButton.querySelector('span');
            const updatedTextForVariantChange = updatedSubmit.querySelector('span');
            if (currentTextForVariantChange && updatedTextForVariantChange) {
              currentTextForVariantChange.innerHTML = updatedTextForVariantChange.innerHTML;
            }
            this.rlxSyncQuantityDisabled(false);
            this.rlxReapplyCartAddBusy();
            return;
          }
          /*
            RELAXIM 追加: 売切れ方向だけ購入ボタンへ同期する。
            有効化は通常の有効variant切替（Dawnが disabled を外す既存経路）、または
            上の数量上限専用復帰分岐に任せる。
          */
          if (updatedDisabled) this.rlxSyncSubmitSoldOut(sectionId, html);
          const submitDisabled = this.submitButton ? this.submitButton.hasAttribute('disabled') : false;
          this.rlxSyncQuantityDisabled(updatedDisabled || submitDisabled);
        }
      }

      /*
        RELAXIM 追加: 数量上限到達由来の専用状態からの復帰可否を判定する。
        無効な組合せ選択中はDawnがhidden variant IDを旧variantのまま残し、購入ボタンの
        disabled・文言もvariant picker側が独自に書き換える（本クラスの同期処理を経由しない）。
        この状態で旧variant自体は有効なcartUpdate応答が届くと、字面上の4条件だけでは
        区別できず誤って復帰してしまう（第10回追検品で実測）。次を全て満たす場合だけ復帰を許可する。
        1. 現在のhidden variant IDが、上限到達時に記録したIDと一致。
        2. 現在の購入ボタン文言が、上限到達時に記録した文言と一致
           （variant picker側が独自に書き換えていれば、ここで不一致として検出できる）。
        3-4. variant picker（variant-radios/variant-selects）が存在する場合、
             その現在選択が有効なvariantに一致し、かつhidden variant IDと一致すること。
             現在選択を確認できない場合はfail-closed。
      */
      rlxCanRecoverFromQuantityLimit() {
        if (!this.currentVariant) return false;
        const currentVariantId = this.currentVariant.value;
        if (currentVariantId !== this.rlxQuantityLimitVariantId) return false;

        const submitTextEl = this.submitButton ? this.submitButton.querySelector('span') : null;
        const currentSubmitText = submitTextEl ? submitTextEl.innerHTML : null;
        if (currentSubmitText !== this.rlxQuantityLimitSubmitText) return false;

        return this.rlxIsPickerVariantValidAndMatching(currentVariantId);
      }

      /*
        RELAXIM 追加: Observer（rlxHandleSubmitStateObserved）専用の復帰可否判定。
        Observerは外部（variant picker等）が購入ボタンを有効化した「後」に追従するだけなので、
        その時点の購入ボタン文言は既に外部の新しい文言へ書き換わっている。rlxCanRecoverFromQuantityLimit()の
        文言一致条件をそのまま使うと、正規の有効化後でも記録時点の文言（例:『売り切れ』）と
        一致せず常にfail-closedになってしまう。そのためObserver専用では、依頼書が明記する
        条件（hidden variant IDの一致、pickerがあれば現在選択が有効でhidden IDと一致）だけを見る。
      */
      rlxCanRecoverFromQuantityLimitViaObserver() {
        if (!this.currentVariant) return false;
        const currentVariantId = this.currentVariant.value;
        if (currentVariantId !== this.rlxQuantityLimitVariantId) return false;
        return this.rlxIsPickerVariantValidAndMatching(currentVariantId);
      }

      /*
        RELAXIM 追加: updateQuantityRules()のvariantChange専用復帰判定
        （第13回検品 中2）。数量上限到達variant Aとは異なる、現在選択中の
        variant Bへの正規切替可否を判定する。同一variantの復帰は
        rlxCanRecoverFromQuantityLimit()が担当するため、ここでは必ず
        「現在のhidden IDが記録IDと異なる」ことを前提条件にする。
        rlxIsPickerVariantValidAndMatching()と異なり、pickerが存在しない場合は
        単一variant商品とみなさずfalseを返す。別variantへの切替が起きている以上、
        pickerが存在しないのは想定外の状態であり、fail-closedを優先する。
      */
      rlxCanRecoverFromQuantityLimitViaVariantChange(responseVariantId, updatedVariantId) {
        if (!this.currentVariant) return false;
        const currentVariantId = this.currentVariant.value;
        if (!currentVariantId) return false;
        if (currentVariantId === this.rlxQuantityLimitVariantId) return false;
        if (!this.variantSelects) return false;
        const pickerVariantId = this.rlxResolvePickerVariantId(this.variantSelects);
        if (pickerVariantId === undefined || pickerVariantId === null) return false;
        /*
          RELAXIM 追加（第14回検品 不合格1）: 現在のhidden ID・pickerの現在選択・
          応答variant ID（event.data.variant.id）・更新HTML内variant IDの4値すべてが
          空でなく、String()正規化後に完全一致する場合だけ別variant復帰を許可する。
          いずれか欠落・不一致はfail-closed（false）。responseVariantId /
          updatedVariantId は connectedCallback のvariantChange購読側で既に
          「古い応答は破棄」済みの前提で渡されるが、直接呼び出し（cartUpdate等）からは
          渡されないため、ここでも独立して欠落チェックする。
        */
        if (!responseVariantId) return false;
        if (!updatedVariantId) return false;
        const normalizedCurrent = String(currentVariantId);
        const normalizedPicker = String(pickerVariantId);
        const normalizedResponse = String(responseVariantId);
        const normalizedUpdated = String(updatedVariantId);
        if (normalizedPicker !== normalizedCurrent) return false;
        if (normalizedResponse !== normalizedCurrent) return false;
        if (normalizedUpdated !== normalizedCurrent) return false;
        return true;
      }

      /*
        RELAXIM 追加（第14回検品 不合格1）: variantChangeで受け取った更新HTMLから、
        `#product-form-${sectionId} .product-variant-id` のvariant IDを取得する。
        html.querySelectorが無い呼び出し（数量フォーム欠落テスト等の簡易モック）や
        該当要素が無い場合はnullを返し、呼び出し側でfail-closedとして扱わせる。
      */
      rlxExtractUpdatedVariantId(sectionId, html) {
        if (!html || typeof html.querySelector !== 'function') return null;
        const el = html.querySelector(`#product-form-${sectionId} .product-variant-id`);
        if (!el) return null;
        const value = el.value;
        return value === undefined || value === null || value === '' ? null : String(value);
      }

      /*
        RELAXIM 追加: variant picker（variant-radios/variant-selects）が存在しない場合は
        単一variantとして扱い、picker側の条件を課さない（true）。存在する場合は、
        現在選択が有効なvariantに一致し、かつhidden variant IDと一致する場合だけtrueを返す。
        現在選択を確認できない場合はfail-closed（false）。
      */
      rlxIsPickerVariantValidAndMatching(currentVariantId) {
        if (!this.variantSelects) return true;
        const pickerVariantId = this.rlxResolvePickerVariantId(this.variantSelects);
        if (pickerVariantId === undefined || pickerVariantId === null) return false;
        return String(pickerVariantId) === String(currentVariantId);
      }

      /*
        RELAXIM 追加: variant picker（variant-radios/variant-selects）の現在選択から、
        一致するvariantのIDを解決する。Dawn標準のvariant-selects/variant-radiosは
        自身に埋め込まれたJSON（[type="application/json"]）と、select/fieldset(radio)の
        現在選択値から一致するvariantを算出するため、同じ手順を picker のインスタンス状態に
        依存せず再計算する（ユーザー操作が一度も無い初期状態でも判定できるようにするため）。
        戻り値: variant ID（有効な組合せ） / null（一致するvariantが無い＝無効な組合せ） /
        undefined（JSON・選択値を確認できない＝判定不能）。
      */
      rlxResolvePickerVariantId(picker) {
        const dataScript = picker.querySelector('script[type="application/json"]');
        if (!dataScript) return undefined;
        let variants;
        try {
          variants = JSON.parse(dataScript.textContent);
        } catch (e) {
          return undefined;
        }
        if (!Array.isArray(variants)) return undefined;

        const fields = picker.querySelectorAll('select, fieldset');
        if (!fields || fields.length === 0) return undefined;
        const selected = Array.from(fields).map((element) => {
          if (element.tagName === 'SELECT') return element.value;
          if (element.tagName === 'FIELDSET') {
            const checked = Array.from(element.querySelectorAll('input')).find((input) => input.checked);
            return checked ? checked.value : undefined;
          }
          return undefined;
        });
        if (selected.some((value) => value === undefined)) return undefined;

        const matched = variants.find(
          (variant) =>
            Array.isArray(variant.options) &&
            variant.options.length === selected.length &&
            variant.options.every((option, index) => option === selected[index])
        );
        return matched ? matched.id : null;
      }

      /*
        RELAXIM 追加: 更新HTML側が売切れの場合に、購入ボタンの disabled と売切れ文言を現在の
        購入ボタンへ同期する。更新HTMLの購入ボタンが販売可能なら何もしない（fail-closed）。
        後着応答は fetchQuantityRules() 側で破棄済みのため、ここへは到達しない。
      */
      rlxSyncSubmitSoldOut(sectionId, html) {
        if (!this.submitButton || !html || typeof html.getElementById !== 'function') return;
        const updatedSubmit = html.getElementById(`ProductSubmitButton-${sectionId}`);
        if (!updatedSubmit || !updatedSubmit.hasAttribute('disabled')) return;
        this.rlxRememberServerPurchaseState(false);
        this.submitButton.setAttribute('disabled', 'disabled');
        const currentText = this.submitButton.querySelector('span');
        const updatedText = updatedSubmit.querySelector('span');
        if (currentText && updatedText) {
          currentText.innerHTML = updatedText.innerHTML;
        }
        this.rlxReapplyCartAddBusy();
      }
    }
  );
}
